import {
  Box,
  Divider,
  Grid,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React from "react";
import "./TripDetails.css";

const TripDetails = () => {
  return (
    <>
      <Grid container alignItems="center">
        <Grid
          item
          xs={12}
          sx={{
            display: "flex",
            justifyContent: "flex-start",
            gap: 2,
            marginBottom: "15px;",
          }}
        >
          <Typography
            style={{
              fontSize: "16px",
              fontWeight: "bold",
              fontFamily: "Sans-Serif",
            }}
            variant="h4"
          >
            Last Trip Details
          </Typography>
        </Grid>
      </Grid>
      <Divider />
      <Grid
        container
        alignItems="center"
        style={{ maxHeight: "300px", overflowY: "scroll" }}
      >
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <TableContainer aria-label="simple table">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <Typography variant="subtitle2" fontWeight={600}>
                      Trip Name
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="subtitle2" fontWeight={600}>
                      Distance
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="subtitle2" fontWeight={600}>
                      Vehicle No
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="subtitle2" fontWeight={600}>
                      Date
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>
                    <Stack direction="row" spacing={2}>
                      <Box>
                        <Typography variant="subtitle2" fontWeight={600}>
                          Ranchi To Bokaro
                        </Typography>
                      </Box>
                    </Stack>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="subtitle2"
                      fontWeight={400}
                    >
                      200 km
                    </Typography>
                  </TableCell>
                  <TableCell>JH01AB1435</TableCell>
                  <TableCell>
                    <Typography variant="subtitle2">02-01-2024</Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Stack direction="row" spacing={2}>
                      <Box>
                        <Typography variant="subtitle2" fontWeight={600}>
                          Ranchi To Bokaro
                        </Typography>
                      </Box>
                    </Stack>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="subtitle2"
                      fontWeight={400}
                    >
                      200 km
                    </Typography>
                  </TableCell>
                  <TableCell>JH01AB1435</TableCell>
                  <TableCell>
                    <Typography variant="subtitle2">02-01-2024</Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Stack direction="row" spacing={2}>
                      <Box>
                        <Typography variant="subtitle2" fontWeight={600}>
                          Ranchi To Bokaro
                        </Typography>
                      </Box>
                    </Stack>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="subtitle2"
                      fontWeight={400}
                    >
                      200 km
                    </Typography>
                  </TableCell>
                  <TableCell>JH01AB1435</TableCell>
                  <TableCell>
                    <Typography variant="subtitle2">02-01-2024</Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Stack direction="row" spacing={2}>
                      <Box>
                        <Typography variant="subtitle2" fontWeight={600}>
                          Ranchi To Bokaro
                        </Typography>
                      </Box>
                    </Stack>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="subtitle2"
                      fontWeight={400}
                    >
                      200 km
                    </Typography>
                  </TableCell>
                  <TableCell>JH01AB1435</TableCell>
                  <TableCell>
                    <Typography variant="subtitle2">02-01-2024</Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Stack direction="row" spacing={2}>
                      <Box>
                        <Typography variant="subtitle2" fontWeight={600}>
                          Ranchi To Bokaro
                        </Typography>
                      </Box>
                    </Stack>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textSecondary"
                      variant="subtitle2"
                      fontWeight={400}
                    >
                      200 km
                    </Typography>
                  </TableCell>
                  <TableCell>JH01AB1435</TableCell>
                  <TableCell>
                    <Typography variant="subtitle2">02-01-2024</Typography>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
    </>
  );
};

export default TripDetails;
